// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605150932/js/" + chunkId + "." + {"44":"f55de10e","225":"8b0fe5f6","481":"7c15b572","486":"aa1f4a25","770":"7d0ee7bb"}[chunkId] + ".0.5028954959898202.chunk.js";
};